exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "li.docbox {\n    border: 1px solid #dcdcdc;\n    background: #edfaf2;\n    padding: 4px 4px 4px 8px;\n    font-size: 13px;\n    font-weight: bold;\n    border-radius: 4px;\n    list-style: none;\n}\n\n.docbox span {\n    padding-left: 10px;\n}\n\ni.fa.fa-cloud-download {\n    float: right;\n    color: #007bff;\n    cursor: pointer;\n    font-weight: bold;\n    padding: 4px 4px 4px 8px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/projects/wct-nextias-ui/src/app/discussion/addfreedownload/addfreedownload.component.css
// module id = ../../../../../src/app/discussion/addfreedownload/addfreedownload.component.css
// module chunks = common